__turbopack_context__.v({
  "className": "inter_94f71b-module__OJrrXa__className",
  "variable": "inter_94f71b-module__OJrrXa__variable",
});
